import type { PerUnitPricing } from '@weft/types';
import { safeDivision } from '@weft/utils';

export function getRateMultiplierAdjustedPerUnitPricing(pricing: PerUnitPricing, rateMultiplier: number): PerUnitPricing {
  return {
    ...pricing,
    priceConfiguration: {
      price: safeDivision(pricing.priceConfiguration.price, rateMultiplier),
      chunkSize: pricing.priceConfiguration.chunkSize,
    },
  };
}